import { adminPath } from '@/core/utils/env.utils';

export const CASE_STUDIES_ENDPOINTS = {
  LIST: adminPath('/case-studies'),
  CREATE: adminPath('/case-studies'),
  BY_ID: (id: string) => adminPath(`/case-studies/${id}`),
  UPDATE: (id: string) => adminPath(`/case-studies/${id}`),
  DELETE: (id: string) => adminPath(`/case-studies/${id}`),
} as const;
